import { getDemoMenus, getIsTabbedMenu } from "@/framework/utils/config";

const env = (() => {
  if (/dev/.test(location.hostname)) {
    return ".stage";
  } else if (/test/.test(location.hostname)) {
    return ".stage";
  } else if (/stage/.test(location.hostname)) {
    return ".stage";
  }
  return "";
})();

let showMenu = 0;
let isShowPurchase = 0;
let isShowKeyclient = 0;
let businessType = 0;
let isShwoMustBuyMenu = 0;
let isShowSplitAccMenu = 0;
try {
  showMenu = JSON.parse(localStorage.vuex).userInfo.showMenu;
  businessType = JSON.parse(localStorage.vuex).userInfo.businessType;
  isShowPurchase = JSON.parse(localStorage.vuex).userInfo.isShowPurchase;
  isShowKeyclient = JSON.parse(localStorage.vuex).userInfo.isShowKeyclient;
  isShwoMustBuyMenu = JSON.parse(localStorage.vuex).userInfo.isShwoMustBuyMenu;
  isShowSplitAccMenu = JSON.parse(localStorage.vuex).userInfo.isShowSplitAccMenu;
} catch (e) { }

let mainMenuConfig = [
  {
    name: "客户首页",
    icon: "el-icon-s-custom",
    path: "/customerManagement/detail"
  },
  {
    name: "门店管理",
    icon: "el-icon-s-home",
    path: "/storeManagement/list"
  },
  // {
  //   name: "门店创建管理",
  //   icon: "el-icon-s-home",
  //   path: "/storeManagement/listCreate"
  // },
  {
    name: "人员管理",
    icon: "el-icon-user",
    path: "/personnelManagement/list"
  }
];

if (showMenu === 1 && isShowPurchase) {
  mainMenuConfig.push({
    name: "商品管理",
    icon: "el-icon-shopping-cart-full",
    path: "/products",
    children: [
      {
        name: "采购单管理",
        path: `/iframe/?url=https://keyclient${env}.yunshanmeicai.com/purchaseListConfig/purchaseListIndex`
      }
    ]
  });
}

if (isShwoMustBuyMenu === 1) {
  mainMenuConfig.push({
    name: "必采商品管理",
    icon: "el-icon-user",
    path: "/bcRelationManagerment/index"
  });
}

if (isShowSplitAccMenu === 1) {
  mainMenuConfig.push({
    name: "分账管理",
    icon: "el-icon-s-goods",
    path: "/splitAccount",
    children: [
      {
        "name": "分账主体管理",
        "path": "/list"
      },
      {
        "name": "主体账单管理",
        "path": "/bill"
      }
    ]
  });
}

mainMenuConfig.push({
  name: "订单管理",
  icon: "el-icon-s-goods",
  path: "/orderManagement/list",
  //path: `/iframe/?url=https://dmallcs${env}.yunshanmeicai.com/static/dist/views/iframeToBigCus/order_management_bigcus.html`
});

if (showMenu === 1) {
  // mainMenuConfig.push(
  //   {
  //     name: "合同管理",
  //     icon: "el-icon-s-goods",
  //     path: "",
  //     children: [
  //     // {
  //     //   name: "采购合同",
  //     //   icon: "el-icon-s-goods",
  //     //   path: "/contract/index"
  //     // }, 
  //     {
  //       name: "供应链服务协议",
  //       icon: "el-icon-s-goods",
  //       path: "/purchaseAppoint/list"
  //     }
  //     // , {
  //     //   name: "签章管理",
  //     //   icon: "el-icon-s-goods",
  //     //   path: "/signature/index"
  //     // }
  //     ]
  //   },
  // );
  mainMenuConfig.push({
    name: "财务管理",
    icon: "el-icon-s-data",
    path: "/bills",
    children: [
      {
        name: "对账汇总",
        path: "/list"
        //path: `/iframe/?url=https://keyclient${env}.yunshanmeicai.com/bill/index`
      },
      {
        name: "对账明细",
        path: "/detail"
        //path: `/iframe/?url=https://keyclient${env}.yunshanmeicai.com/bill/detail/index`
      },
      {
        name: "导出任务",
        path: isShowKeyclient ? `/iframe/?url=https://keyclient${env}.yunshanmeicai.com/bill/export/index` : '/billExport'
      },
      // {
      //   name: "商品汇总",
      //   path: isShowKeyclient ? `/iframe/?url=https://keyclient${env}.yunshanmeicai.com/bill/goods/index` : '/billGoods'
      // },
      // {
      //   name: "老版对账单",
      //   path: `/iframe/?url=https://dmallcs${env}.yunshanmeicai.com/static/dist/views/iframeToBigCus/bill_management.html`
      // }
    ]
  });
}
//管家自营6，管家直供96，管家POP27
if (businessType === 6 || businessType === 96 || businessType === 27) {
  mainMenuConfig.push({
    name: "报表管理",
    icon: "el-icon-s-data",
    path: "/reports",
    children: [
      {
        name: "商品库存数据（试运行）",
        path: "/skustock"
      }
    ]
  });
}


mainMenuConfig = mainMenuConfig.concat(getDemoMenus());
let isTabbedMenu = getIsTabbedMenu();
export { mainMenuConfig, isTabbedMenu ,isShowKeyclient};
